import { SOCIAL_AUTH_NAME, SOCIAL_NAME, SOCIAL_REGEX, SOCIAL_SHARE_URL } from 'constants/social'
import { getApiServiceUrlEnvironmentUtil, getWebsiteUrlEnvironmentUtil } from 'modules/environment/utils'

function getShareUrlsSocialUtil (title, url, img) {
  // Add protocol
  if (img && img.indexOf('//') === 0) {
    img = img.replace('//', 'https://')
  }
  // Prefix the url depending on the env
  url = getWebsiteUrlEnvironmentUtil() + url
  const encodedUrl = encodeURIComponent(url)
  const shareUrl = {}
  Object.keys(SOCIAL_SHARE_URL).forEach(social => {
    const urlTemplate = SOCIAL_SHARE_URL[social]
    const data = [
      encodedUrl,
      title
    ]
    if (social === SOCIAL_NAME.PINTEREST) {
      data.push(img)
    } else if (social === SOCIAL_NAME.X) {
      data.push('gymaholic')
    }
    shareUrl[social] = getSocialShareUrl(social, urlTemplate, data)
  })
  return shareUrl
}

/**
 * Gets the social network's share url.
 * @param  {string} social       The social network.
 * @param  {string} urlTemplate  Share url template.
 * @param  {String[]} data
 *
 * Note: the url should be filled in that order: url, title, img
 * @private
 * @returns {string}
 */
function getSocialShareUrl (social, urlTemplate, data) {
  const re = new RegExp(SOCIAL_REGEX.SHARE)
  let match = re.exec(urlTemplate)
  let i = 0
  while (match) {
    urlTemplate = urlTemplate.replace(match[1], data[i])
    match = re.exec(urlTemplate)
    i++
  }
  return urlTemplate
}

/**
 * Gets the api's auth url.
 * @param  {string} name
 * @returns {string}
 */
function getApiServiceUrlSocialUtil (name) {
  const authUrl = `${getApiServiceUrlEnvironmentUtil()}/auth/`
  return `${authUrl}${SOCIAL_AUTH_NAME[name]}`
}

export {
  getShareUrlsSocialUtil,
  getApiServiceUrlSocialUtil
}
